import { render, staticRenderFns } from "./collapser-cmp.vue?vue&type=template&id=0fd8ba8f&scoped=true&"
import script from "./collapser-cmp.vue?vue&type=script&lang=ts&"
export * from "./collapser-cmp.vue?vue&type=script&lang=ts&"
import style0 from "./collapser-cmp.vue?vue&type=style&index=0&id=0fd8ba8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd8ba8f",
  null
  
)

export default component.exports